module.exports = __webpack_public_path__ + "static/media/03-submenu.5aaa2aa8.png";